import { Injectable } from '@angular/core';
import { Messaging } from '@myworkplace/api';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { globalVar } from '../../shared/global_variables';
import { MyWorkplaceUrls } from './models/MyWorkplaceUrls';

export const MY_WORKPLACE = '/myWorkplace';
export const GET_URLS = '/getUrls';

@Injectable({
    providedIn: 'root'
})
export class MyWorkplaceService {
    constructor(private httpClient: HttpClient) {}

    isAppInsideMyWorkplace(): boolean {
        return Messaging.isWorkplaceEnv();
    }

    public getUrls(): Observable<MyWorkplaceUrls> {
        return this.httpClient.get<MyWorkplaceUrls>(environment.baseUrl + globalVar.requestPrefix + MY_WORKPLACE + GET_URLS, {});
    }

    isUrlComingFromExternalSERA(url: string): boolean {
        return url.includes('bmw.com');
    }

    isUrlComingFromRegularSERA(url: string): boolean {
        return url.includes('bmwgroup.net') || url.includes('azure.cloud.bmw');
    }
}
